// extracted by mini-css-extract-plugin
export default {"cloud":"style_cloud__AORAg","chip":"style_chip__AXrYg","row":"style_row__CxScl","note":"style_note__m4OOR","label":"style_label__6Jbtf","value":"style_value__bTBYz"};